// extracted by mini-css-extract-plugin
module.exports = {"summary":"MealSummery_summary__3eyX4"};